import { Component, Input, OnInit } from "@angular/core";
import { AssistantService } from "../../../services/assistant.service";

@Component({
    selector: "app-assistant-banner-content-links",
    templateUrl: "./assistant-banner-content-links.component.html",
    styleUrls: ["./assistant-banner-content-links.component.scss"],
    standalone: false
})
export class AssistantBannerContentLinksComponent implements OnInit {
  @Input() links: string[];

  constructor(private assistantService: AssistantService) {}

  ngOnInit(): void {}

  onHelp(): void {
    this.assistantService.showSupportAgent();
  }
}
